export default __webpack_public_path__ + "static/2-6-2-0-5dd1ddc96e50a95692854914819a4c1d.jpg";